// API functions for PatentFullTextDisplay - matches patentloop-frontend implementation
import { API_CONFIG } from '@/config/api.config';
import { encryptData, decryptData } from '@/utils/encryption';
import axios from 'axios';

export const fetchPatentFullText = async (patentNumber: string) => {
  const cacheKey = `patent_${patentNumber}`;

  // Check 7-day localStorage cache first (same as patentloop-frontend)
  try {
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      const age = Date.now() - timestamp;
      const maxAge = 7 * 24 * 60 * 60 * 1000; // 7 days

      if (age < maxAge) {
        console.log('Returning cached patent data for:', patentNumber);
        return data;
      }
    }
  } catch (e) {
    console.warn('Error reading patent cache:', e);
  }

  // Fetch from server using public GET endpoint (no auth required)
  try {
    const response = await fetch(`${API_CONFIG.baseUrl}/${patentNumber}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch patent: ${response.statusText}`);
    }

    const data = await response.json();

    // Cache the result locally for 7 days
    try {
      localStorage.setItem(cacheKey, JSON.stringify({
        data,
        timestamp: Date.now()
      }));
    } catch (e) {
      console.warn('Error caching patent data:', e);
    }

    return data;
  } catch (error) {
    console.error('Error fetching patent full text:', error);
    throw error;
  }
};

export const checkLogin = async () => {
  try {
    const idToken = localStorage.getItem('id_token');
    const username = localStorage.getItem('username');

    if (!idToken || !username) {
      return null;
    }

    const encryptedData = encryptData({ id_token: idToken, username: username });
    const response = await axios.post(`${API_CONFIG.baseUrl}/user/check_login`, {
      credentials: 'include',
      data: encryptedData
    });

    const decryptedResponse = decryptData(response.data);

    // Update id_token if present in response
    if (decryptedResponse?.id_token) {
      localStorage.setItem('id_token', decryptedResponse.id_token);
    }

    return decryptedResponse;
  } catch (error) {
    console.error('Error checking login:', error);
    return null;
  }
};
